var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 32.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-width:2px;}.cls-1{stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.6,24.79c1.48-.61,2.59-2,3.93-4.44C42.94,18.25,39,19.5,36.45,24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.33,29.46c2.53,2.42,6.29,4.07,11-.9C39.23,25.57,34.9,25.73,31.33,29.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,16.82c1.57-1.09,2.74-3.11,3-6.67-4.33-.28-7.55,2.61-7.89,7.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,8.31c1.06-1.59,1.41-3.91.31-7.31-4.13,1.33-6,5.21-4.46,10.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.4,24.79c-1.48-.61-2.59-2-3.93-4.44C5.06,18.25,9,19.5,11.55,24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.67,29.46c-2.53,2.42-6.29,4.07-11-.9C8.77,25.57,13.1,25.73,16.67,29.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,16.82c-1.57-1.09-2.74-3.11-3-6.67,4.33-.28,7.55,2.61,7.89,7.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,8.31C3.92,6.72,3.57,4.4,4.67,1,8.8,2.33,10.72,6.21,9.13,11.14"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 24,
    cy: 15,
    r: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24 8.53 25.95 12.52 30.16 13 27.16 16.24 27.8 20.24 24 18.54 20.2 20.24 20.84 16.24 17.84 13 22.05 12.52 24 8.53"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank);
export default __webpack_public_path__ + "static/media/rank.6c057078f09d2bd874b3716016edbecc.svg";
export { ForwardRef as ReactComponent };